import { input } from '../../common/requests/base.input.ts';
import { mutation } from '../../common/requests/base.mutation.ts';
import { ResultType } from '../../main/types/result.types.ts';
import { getReadingCrittersClientUtil } from '../../main/utils/clients/readingcritters.client.util.ts';
import { getLocaleUtil } from '../../main/utils/locale.util.ts';

import { mapCheckWritingGraderTypeToBackendType } from '../mappers/check-writing-grader-type.mapper.ts';
import { CheckWritingInput, CheckWritingResult, CheckWritingResultSchema } from '../types/check-writing.types.ts';

const CHECK_WRITING_MUTATION = mutation({
  checkWriting: [
    { input: input('input', 'CheckWritingInput!') },
    {
      evaluation: true,
      storageKey: true,
    },
  ],
});

export const checkWritingMutationRequest = async (
  props: CheckWritingInput
): Promise<ResultType<CheckWritingResult>> => {
  const client = getReadingCrittersClientUtil();

  const response = await client.mutation(
    CHECK_WRITING_MUTATION,
    {
      input: {
        userPath: props.userPath,
        referencePath: props.referencePath,
        reference: props.reference,
        type: mapCheckWritingGraderTypeToBackendType(props.type),
      },
    },
    { useAuth: true }
  );

  if (!response?.checkWriting) {
    return {
      success: false,
      message: getLocaleUtil().select('learn:check_writing_failed'),
    };
  }

  return {
    success: Boolean(response?.checkWriting),
    data: CheckWritingResultSchema.parse(response.checkWriting),
  };
};
